// FEJLESZTÉSEK feature — query-kulcs gyár + a lista-szűrő típusa. A hívások a tipizált ts-rest kliensen
// (`api.productUpdates.*`) mennek; a kulcsok itt élnek, hogy a cache-invalidálás egy helyen legyen.
// A szerződés forrás-igazsága a `@atlas/contracts` — itt csak kulcs/segéd-logika van.

/**
 * A KÉT NÉZET — ugyanannak a halmaznak két olvasata: a `board` a folyamat (a friss kiadásokkal együtt),
 * a `timeline` a kiadás-történet. Nem adat-vágás: egy kiadott tétel mindkettőn szerepel.
 */
export type ProductUpdateTab = 'board' | 'timeline';

/**
 * A lista-lekérdezés szűrői (a query-kulcs része — szűrő-váltás új cache-bejegyzést nyit).
 *
 * A LAP-SZÁM SZÁNDÉKOSAN NINCS BENNE: a lap végtelen görgetéssel tölt (`useInfiniteQuery`), tehát a lapok
 * EGY cache-bejegyzésben halmozódnak — a kulcsba tett lap-szám minden görgetésnél új bejegyzést nyitna.
 */
export interface ProductUpdateListFilters {
  tab: ProductUpdateTab;
  q: string;
  stage: string;
  type: string;
  status: string;
  visibility: string;
}

export const productUpdateKeys = {
  all: ['product-updates'] as const,
  lists: () => ['product-updates', 'list'] as const,
  list: (filters: ProductUpdateListFilters) => ['product-updates', 'list', filters] as const,
  detail: (id: string) => ['product-updates', 'detail', id] as const,
};
